"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _useDidUpdateEffect = _interopRequireDefault(require("../../hooks/useDidUpdateEffect"));
var _AttachMoney = _interopRequireDefault(require("@material-ui/icons/AttachMoney"));
var _SupervisorAccount = _interopRequireDefault(require("@material-ui/icons/SupervisorAccount"));
var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));
var _numbers = require("../../utils/numbers");
var _reactUse = require("react-use");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    item: {
      height: theme.spacing(4)
    }
  };
});
var StyledSlider = (0, _styles.styled)(_Slider["default"])(function (_ref) {
  var theme = _ref.theme;
  return {
    paddingBottom: theme.spacing(1),
    "& .MuiSlider-rail": {
      height: 4
    },
    "& .MuiSlider-track": {
      height: 4
    }
  };
});
var FeatureItem = function FeatureItem(_ref2) {
  var feature = _ref2.feature,
    isAll = _ref2.isAll,
    features = _ref2.features,
    setFeatures = _ref2.setFeatures,
    isAllChecked = _ref2.isAllChecked,
    setIsAllChecked = _ref2.setIsAllChecked;
  var _useStyles = useStyles(),
    item = _useStyles.item;
  var _useState = (0, _react.useState)(features.map(function (f) {
      return f.id;
    }).includes(feature.id)),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var isChecked = (0, _react.useMemo)(function () {
    return features.map(function (f) {
      return f.id;
    }).includes(feature.id);
  }, [features]);
  (0, _react.useEffect)(function () {
    setChecked(isChecked);
  }, [features]);
  var handleCheck = function handleCheck(e) {
    if (isAll) {
      setIsAllChecked(!isAllChecked);
      return;
    }
    setIsAllChecked(false);
    // time out acts as next tick here
    setTimeout(function () {
      var ffs = isChecked ? _toConsumableArray(features).filter(function (cg) {
        return cg.id !== feature.id;
      }) : [].concat(_toConsumableArray(features), [feature]);
      setFeatures(ffs);
    }, 0);
  };
  return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    dense: true,
    className: item,
    onClick: handleCheck,
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    color: "primary",
    edge: "start",
    checked: isAll ? isAllChecked : checked,
    disableRipple: true
  })), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "body2"
  }, feature.name)));
};
var BoatTypeItem = function BoatTypeItem(_ref3) {
  var boatType = _ref3.boatType,
    selectedBoatTypes = _ref3.selectedBoatTypes,
    setSelectedBoatTypes = _ref3.setSelectedBoatTypes;
  var _useStyles2 = useStyles(),
    item = _useStyles2.item;
  var isChecked = selectedBoatTypes.map(function (bt) {
    return bt.id;
  }).includes(boatType.id);
  var handleCheck = function handleCheck() {
    if (isChecked) {
      setSelectedBoatTypes(selectedBoatTypes.filter(function (bt) {
        return bt.id !== boatType.id;
      }));
    } else {
      setSelectedBoatTypes([].concat(_toConsumableArray(selectedBoatTypes), [boatType]));
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    dense: true,
    className: item,
    onClick: handleCheck,
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    color: "primary",
    edge: "start",
    checked: isChecked,
    disableRipple: true
  })), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "body2"
  }, boatType.name)));
};
var BoatTypesGroup = function BoatTypesGroup(_ref4) {
  var boatTypes = _ref4.boatTypes,
    selectedBoatTypes = _ref4.selectedBoatTypes,
    setSelectedBoatTypes = _ref4.setSelectedBoatTypes;
  var _useStyles3 = useStyles(),
    item = _useStyles3.item;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    collaped = _useState4[0],
    setCollaped = _useState4[1];
  var allSelected = boatTypes.length > 0 && boatTypes.every(function (bt) {
    return selectedBoatTypes.map(function (s) {
      return s.id;
    }).includes(bt.id);
  });
  var handleSelectAll = function handleSelectAll() {
    if (allSelected) {
      setSelectedBoatTypes([]);
    } else {
      setSelectedBoatTypes(_toConsumableArray(boatTypes));
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    onClick: function onClick() {
      return setCollaped(!collaped);
    },
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "subtitle1",
    gutterBottom: true
  }, "Boat Type")), collaped ? /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    "in": !collaped
  }, boatTypes.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    dense: true,
    className: item,
    onClick: handleSelectAll,
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    color: "primary",
    edge: "start",
    checked: allSelected,
    disableRipple: true
  })), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "body2"
  }, "Select All"))), (boatTypes || []).map(function (boatType) {
    return /*#__PURE__*/_react["default"].createElement(BoatTypeItem, {
      key: boatType.id,
      boatType: boatType,
      selectedBoatTypes: selectedBoatTypes,
      setSelectedBoatTypes: setSelectedBoatTypes
    });
  })))), /*#__PURE__*/_react["default"].createElement(_core.Divider, null));
};
var FeatureGroup = function FeatureGroup(_ref5) {
  var group = _ref5.group,
    features = _ref5.features,
    setFeatures = _ref5.setFeatures;
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isAllChecked = _useState6[0],
    setIsAllChecked = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    collaped = _useState8[0],
    setCollaped = _useState8[1];
  (0, _useDidUpdateEffect["default"])(function () {
    setFeatures(isAllChecked ? [].concat(_toConsumableArray(features), _toConsumableArray(group.features)) : _toConsumableArray(features.filter(function (f) {
      return group.features.map(function (gf) {
        return gf.id;
      }).includes(f.id) === false;
    })));
  }, [isAllChecked]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    onClick: function onClick() {
      return setCollaped(!collaped);
    },
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "subtitle1",
    gutterBottom: true
  }, group.name)), collaped ? /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    "in": !collaped
  }, group.features.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(FeatureItem, {
    feature: {
      name: "Select All"
    },
    group: group,
    isAll: true,
    features: features,
    setFeatures: setFeatures,
    isAllChecked: isAllChecked,
    setIsAllChecked: setIsAllChecked
  }), (group.features || []).map(function (feature, index) {
    return /*#__PURE__*/_react["default"].createElement(FeatureItem, {
      key: index,
      group: group,
      feature: feature,
      features: features,
      setFeatures: setFeatures,
      isAllChecked: isAllChecked,
      setIsAllChecked: setIsAllChecked
    });
  })))), /*#__PURE__*/_react["default"].createElement(_core.Divider, null));
};
var PriceGroup = function PriceGroup(_ref6) {
  var minPrice = _ref6.minPrice,
    maxPrice = _ref6.maxPrice,
    setMinPrice = _ref6.setMinPrice,
    setMaxPrice = _ref6.setMaxPrice;
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    collaped = _useState10[0],
    setCollaped = _useState10[1];
  var minVal = Number(minPrice) || 150;
  var maxVal = Number(maxPrice) || 4000;
  var _useState11 = (0, _react.useState)([minVal, maxVal]),
    _useState12 = _slicedToArray(_useState11, 2),
    priceRange = _useState12[0],
    setPriceRange = _useState12[1];

  // Sync slider when min/max price change from outside (e.g. URL params)
  (0, _react.useEffect)(function () {
    setPriceRange([minVal, maxVal]);
  }, [minVal, maxVal]);
  (0, _reactUse.useDebounce)(function () {
    setMinPrice(priceRange[0]);
    setMaxPrice(priceRange[1]);
  }, 500, [priceRange]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    onClick: function onClick() {
      return setCollaped(!collaped);
    },
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "subtitle1",
    gutterBottom: true
  }, "Price Range")), collaped ? /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    "in": !collaped
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2"
  }, "Select an Hourly Rate"), /*#__PURE__*/_react["default"].createElement(StyledSlider, {
    value: priceRange,
    valueLabelDisplay: "off",
    min: 150,
    max: 4000,
    step: 50,
    onChange: function onChange(e, value) {
      setPriceRange(value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2",
    color: "textSecondary",
    style: {
      textAlign: "left"
    }
  }, "$", (0, _numbers.formatNumber)(priceRange[0])), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2",
    color: "textSecondary",
    style: {
      textAlign: "right"
    }
  }, "$", (0, _numbers.formatNumber)(priceRange[1]))))))));
};
var CapacityGroup = function CapacityGroup(_ref7) {
  var capacity = _ref7.capacity,
    setCapacity = _ref7.setCapacity;
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    collaped = _useState14[0],
    setCollaped = _useState14[1];
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
    button: true,
    onClick: function onClick() {
      return setCollaped(!collaped);
    },
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "textPrimary",
    variant: "subtitle1",
    gutterBottom: true
  }, "Capacity")), collaped ? /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    "in": !collaped
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    value: capacity,
    variant: "outlined",
    size: "small",
    label: "Capacity",
    InputProps: {
      startAdornment: /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(_SupervisorAccount["default"], {
        fontSize: "small"
      }))
    },
    onChange: function onChange(e) {
      return setCapacity(e.target.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2"
  }, "enter a number or a range eg 10 or 10-20"))))));
};
function Filter(_ref8) {
  var groups = _ref8.groups,
    features = _ref8.features,
    setFeatures = _ref8.setFeatures,
    showPrice = _ref8.showPrice,
    minPrice = _ref8.minPrice,
    maxPrice = _ref8.maxPrice,
    setMinPrice = _ref8.setMinPrice,
    setMaxPrice = _ref8.setMaxPrice,
    capacity = _ref8.capacity,
    setCapacity = _ref8.setCapacity,
    showCapacity = _ref8.showCapacity,
    boatTypes = _ref8.boatTypes,
    selectedBoatTypes = _ref8.selectedBoatTypes,
    setSelectedBoatTypes = _ref8.setSelectedBoatTypes;
  var clear = function clear() {
    setFeatures([]);
    if (setSelectedBoatTypes) {
      setSelectedBoatTypes([]);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_core.List, {
    disablePadding: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    spacing: 2,
    container: true,
    alignItems: "center",
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h6"
  }, "Filter boats")), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    size: "small",
    color: "primary",
    fullWidth: true,
    variant: "outlined",
    onClick: clear
  }, "Show all")), showPrice && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(PriceGroup, {
    minPrice: minPrice,
    setMinPrice: setMinPrice,
    maxPrice: maxPrice,
    setMaxPrice: setMaxPrice
  })), showCapacity && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(CapacityGroup, {
    capacity: capacity,
    setCapacity: setCapacity
  }))), /*#__PURE__*/_react["default"].createElement(_core.Divider, null), boatTypes && boatTypes.length > 0 && setSelectedBoatTypes && /*#__PURE__*/_react["default"].createElement(BoatTypesGroup, {
    boatTypes: boatTypes,
    selectedBoatTypes: selectedBoatTypes || [],
    setSelectedBoatTypes: setSelectedBoatTypes
  }), (groups || []).map(function (group, i) {
    return /*#__PURE__*/_react["default"].createElement(FeatureGroup, {
      group: group,
      key: i,
      features: features,
      setFeatures: setFeatures
    });
  }));
}
Filter.propTypes = {
  groups: _propTypes["default"].arrayOf(_propTypes["default"].object),
  features: _propTypes["default"].arrayOf(_propTypes["default"].object),
  setFeatures: _propTypes["default"].func,
  boatTypes: _propTypes["default"].arrayOf(_propTypes["default"].object),
  selectedBoatTypes: _propTypes["default"].arrayOf(_propTypes["default"].object),
  setSelectedBoatTypes: _propTypes["default"].func
};
var _default = exports["default"] = Filter;